import type { SolidRequestContext } from '@app/shared/types/sf-data'

// Tells the preload loader that a Solid template is shown, so it refreshes
// the client file's data. The template's request context names the client
// file, the period and the reconciliation text.
export const refreshSolidData = ({
  firmId,
  companyId,
  ledgerId,
  reconciliationTextId,
}: SolidRequestContext): void => {
  void window.silverfinSolidData?.loadData(
    firmId,
    companyId,
    ledgerId,
    reconciliationTextId
  )
}
